import { Component } from "react";

import { ImageFullResolutionDangerous } from "commonComponents/utilities/ImageFullResolutionDangerous/ImageFullResolutionDangerous";

import "./PrintSignature.less";

interface IProps {
    url: string | undefined | null;
    className?: string;
    /**
     * @default: true
     */
    lazyLoad?: boolean;
}

export class PrintSignature extends Component<IProps> {
    render() {
        if (this.props.url === undefined || this.props.url === null) {
            return <></>;
        }

        return (
            <div className="printSignature">
                <ImageFullResolutionDangerous
                    src={this.props.url}
                    lazyLoad={this.props.lazyLoad}
                    alt="Signature"
                    renderedWidth="getFromServerDangerous"
                    renderedHeight="getFromServerDangerous"
                    className={this.props.className}
                />
            </div>
        );
    }
}
